import React from "react";
import * as Tools from "../../../../helpers/Tools";
import SummaryItemGroup from "./SummaryItemGroup";

const MammographyDontNeed = ({ selectedNoMammographyReason }) => {

    const reason = [
        {
            title: "Reason you don't need a mammogram",
            info: `${selectedNoMammographyReason?.selectedReason}`
        }];

    const getReasonDetails = (selectedReason) => {
        switch (selectedReason) {
            case "Other":
                return [{
                    title: "Your comments",
                    info: `${selectedNoMammographyReason?.description ? selectedNoMammographyReason?.description : 'No comments'}`
                }];
                break;
            case "I already scheduled an appointment":
                const reasonDetails = [];

                if (selectedNoMammographyReason?.data?.procedureMonth || selectedNoMammographyReason?.data?.procedureYear) {
                    reasonDetails.push({
                        title: "Date of Mammogram",
                        info: `${selectedNoMammographyReason?.data?.procedureMonth ? Tools.getFullMonthName(selectedNoMammographyReason?.data?.procedureMonth) : ""} ${selectedNoMammographyReason?.data?.procedureYear ? selectedNoMammographyReason?.data?.procedureYear : ""}`
                    });
                }

                if (selectedNoMammographyReason?.data?.facilityName || selectedNoMammographyReason?.data?.phoneNumber) {
                    reasonDetails.push({
                        title: "Facility",
                        info: <>
                            {selectedNoMammographyReason?.data?.facilityName && <div>{selectedNoMammographyReason?.data?.facilityName}</div>}
                            {selectedNoMammographyReason?.data?.phoneNumber && <div>{selectedNoMammographyReason?.data?.phoneNumber}</div>}
                        </>
                    });
                }

                return reasonDetails;
                break;
            default:
                return [];
                break;
        }
    };

    const reasonDetails = getReasonDetails(selectedNoMammographyReason?.selectedReason);

    const summaryItems = reasonDetails && reasonDetails.length > 0 ? reason.concat(reasonDetails) : reason;

    return (<SummaryItemGroup
        summaryItems={summaryItems}
    />
   );
};

export default MammographyDontNeed;